<nz-modal
  [nzVisible]="showNoTickerPopup"
  [nzTitle]="null"
  nzClosable="true"
  [nzFooter]="null"
  [nzClosable]="false"
  nzMaskClosable="false"
  nzClassName="no-ticker-modal"
  [nzWidth]="558"
  nzWrapClassName="vertical-center-modal"
  [nzContent]="popupContent"
>
</nz-modal>

<ng-template #popupContent>
  <div class="no-tickers-popup">
    <div class="no-tickers-popup-content">
      <div class="no-ticker-popup-info">
        <va-icon [isFontAwesome]="true"
          [name]="faInfoCircle"
          class="mr-4 no-ticker-popup-info-icon"
        ></va-icon>
        <span>Info:</span>
      </div>
      <div class="ml-20">
        No covered companies. <br />
        Please change <b>Market Cap / Regions</b> filter to include more
        results.
      </div>
    </div>
    <va-button
      btnType="solid"
      size="medium"
      class="no-tickers-popup-button mt-16"
      (click)="handleNoTickerPopupChangeClick()"
    >
      Change Now
    </va-button>
  </div>
</ng-template>
